<template>
  <div id="dashboard">
    <div class="container service-board">
      <Slider/>
      <div class="text-body">
        <p>
          “НОМИН БИЗНЕС КАРТ”-ыг танилцуулж байна. Энэхүү карт нь харилцагч Таны
          бизнесийн өдөр тутмын үйл ажиллагаанд бодит дэмжлэг болох
          <b>ХӨНГӨЛӨЛТ, УРАМШУУЛАЛ, ШИНЭ БҮТЭЭГДЭХҮҮН ҮЙЛЧИЛГЭЭ</b>-г түрүүлж
          авах эрхийг багтаасан цагийг тань хэмнэх, байгаль орчинд ээлтэй шийдэл
          бүхий орчин үеийн төлбөрийн дэвшилтэт хэрэгсэл юм.
        </p>
        <p>
          Бизнес картыг дараах байдлаар ашиглах боломжтой байна: <br />
          - Ханган нийлүүлэгч байгууллага, хувь хүн ашиглах боломжтой <br />
          - Бизнес карт нь биетээр ашиглагдах ба пин кодоор баталгаажуулна
          <br />
          - Ариг банкны дебит, кредит эрхтэй төлбөрийн карт хосолсон <br />
          - Ширхэг барааг ч тухайн дэлгүүрийн хамгийн хямд үнээр авах боломжтой
          <br />
          - Бэлтгэн нийлүүлэгчийн, гишүүнчлэлийн /Зөвхөн УБИ салбар дээр
          ашиглагдана/, бонус гэсэн 3 халаастай <br />
          - Жилийн 99,900₮-ийн хураамж төлөөд гишүүнчлэлийн болон бонус халаасыг
          ашиглах боломжтой <br />
          - Жилийн хураамжийг касс дээр төлөн бусад халаасыг нээх боломжтой
          <br />
          - Бэлтгэн нийлүүлэгчийн халаас түрүүлж ашиглагдахаар тохируулагдсан
          <br />
          - Бэлтгэн нийлүүлэгчийн халаас үлдэгдэлгүй үед бонус халаас ашиглах
          боломжтой <br />
          - Бэлтгэн нийлүүлэгчийн халаас ашиглан худалдан авалт хийхэд бонус
          нэмэгдэхгүй, картын хувь тооцох дүнд нэмэгдэх зарчмаар ашиглагдана.
        </p>
        <p>
          НОМИН талаас бизнес картын харилцагчдад дараах нэмэлт урамшуулал,
          үйлчилгээг үзүүлнэ:<br />
          • НОМИН сүлжээ дэлгүүрүүдээс бүх барааг бөөний болон хямдралтай үнээр
          худалдан авах, мерчендайзингийн нэмэлт үйлчилгээнүүдэд БОНУС оноог
          ашиглах. <br />
          • Байгууллагын худалдан авалтыг тусгай борлуулалтын менежерүүдээр
          дамжуулан түргэн шуурхай хийх, хүргэлт үйлчилгээг үнэ төлбөргүй авах.
          <br />
          • Орон нутгийн салбаруудыг бараагаар хангах гэрээ байгуулах, аж ахуйн
          хэрэгцээний тогтмол худалдан авалтыг шуурхай зохион байгуулах гэх мэт
          байгууллага, бизнесүүдэд зориулсан үйлчилгээг авах. <br />
          • Санхүү, даатгалын үйлчилгээг өөрийн хэрэгцээнд тааруулан онцгой
          нөхцөлтэйгөөр хамтран ажиллах. Байгууллагын хэрэгцээгээ цогцоор
          хангах. <br />
          • Номин бизнес картын үндсэн үйлчилгээг хүсэлтийн дагуу авч хамгийн
          өндөр хөнгөлөлт, урамшууллын хувь болох 10% хүртэлх хувийн БОНУС оноо
          цуглуулах, зарцуулах. <br />
          • Номин Даатгал салбарын эрсдэлээс сэргийлсэн даатгалын үйлчилгээнд
          15-25% хүртэлх хувийн хөнгөлөлт эдлэх <br />
          • Nomin.mn онлайн дэлгүүрээс бизнес картаар хийсэн худалдан авалт
          тутамдаа 3% хөнгөлөлтийн кодыг ашиглан нийт худалдан авалтын дүнгээс
          хасах, зөвхөн танд үйлчлэх захиалгын менежер, үнэгүй хүргэлт, түргэн
          шуурхай үйлчилгээ <br />
          • Номин Моторс салбараас ачааны автомашин авахаар төлөвлөж байгаа бол
          зөвхөн танд зориулан үнийн уян хатан нөхцөл, баталгаат хугацааны
          сунгалт, мэргэжлийн баг хамт олны зөвлөгөө үйлчилгээ, ISUZU автомашины
          үнэгүй оношилгоо, үйлчилгээг зөвхөн танд зориулж байна.
        </p>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>

import Slider from '../../components/Slider.vue'
  
  export default {
      components: {
        Slider
  }
}
  </script>


